module.exports = __webpack_public_path__ + "media/images/wpp-bf9f1204527a5cae53a2fc388a8f924c.png";